export const call = {
  state: {
    init: {
      description: `Позволяет направить вызов любому оператору, созданному в АТС. Просмотреть и настроить список операторов можно в разделе`
    }
  },
  input: {
    timeout: {
      label: 'Время ожидания ответа'
    },

    contact: {
      label: 'Контакт метод'
    }
  }
};
